import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cf52be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contract-template-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title_with_line",
  style: {"box-sizing":"border-box","padding":"20px"}
}, " 合同信息 ", -1))
const _hoisted_3 = { style: {"flex":"1","overflow-y":"auto","box-sizing":"border-box","padding":"0 20px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_with_line" }, "填写合同价格", -1))
const _hoisted_5 = {
  key: 1,
  style: {"width":"100%","height":"400px"},
  "element-loading-text": "加载中..."
}
const _hoisted_6 = { class: "affix-box" }

import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ContractDetail from '../components/contract-detail.vue';
import {
  BaseFormItem,
  BaseButton,
  useTableColumn,
  BaseRadioGroup,
  BaseRadio,
  BaseInputNumber,
  BaseTable
} from 'xrk-components';
import { getContractDetail } from '../data-source/apis';
import {
  ContractMenuType,
  ContractStatus,
  RoleType
  // ContractType
} from '../constants';
import { formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'contract-view',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const contractType = ref();

const { id, tab } = route.query as {
  id: string;
  tab: string;
};
const { parentPath, roleText } = route.meta;

const detail = ref<any>({
  firstStatus: ContractStatus.COMPLETED,
  secondStatus: ContractStatus.COMPLETED
});

const columns = [
  useTableColumn({
    type: 'index',
    label: '序号'
  }),
  useTableColumn({
    label: '服务项目',
    prop: 'serviceProjectName'
  }),
  useTableColumn({
    label: '服务场景',
    prop: 'sceneName'
  }),
  useTableColumn({
    label: '甲乙结算单价（不含税/元）',
    prop: 'settlementPrice',
    formatter: ({ cellValue }) => formatter.fen2yuan(cellValue, '元')
  }),
  useTableColumn({
    label: '与自由职业者结算单价',
    prop: 'liberalPrice',
    formatter: ({ cellValue }) => formatter.fen2yuan(cellValue, '元')
  }),
  useTableColumn({
    label: '结算单税率',
    prop: 'settlementScale',
    formatter: ({ cellValue }) =>
      cellValue === null ? '-' : `${Number(cellValue).toFixed(2)}%`
  }),
  useTableColumn({
    label: '平台服务费',
    prop: 'platformServiceScale',
    formatter: ({ cellValue }) =>
      cellValue === null ? '-' : `${Number(cellValue).toFixed(2)}%`
  }),
  useTableColumn({
    label: '服务费占比',
    prop: 'serviceChargeScale',
    formatter: ({ cellValue }) =>
      cellValue === null ? '-' : `${Number(cellValue).toFixed(2)}%`
  })
];

const tableColMid = formData => [
  useTableColumn({
    label: '签署状态',
    prop: 'signStatus',
    render: ({ index }) => (
      <BaseFormItem
        prop={`${index === 0 ? 'first' : 'second'}Status`}
        rules={[
          {
            required: true,
            message: '请选择签署状态',
            trigger: 'change'
          }
        ]}
      >
        <BaseRadioGroup
          v-model={formData.value[`${index === 0 ? 'first' : 'second'}Status`]}
          disabled={true}
        >
          <BaseRadio value={ContractStatus.COMPLETED}>已签</BaseRadio>
          <BaseRadio value={ContractStatus.UNSIGNED}>未签</BaseRadio>
        </BaseRadioGroup>
      </BaseFormItem>
    )
  })
];

const goBack = () => {
  router.push(`${parentPath}?tab=${tab}`);
};

const handleCancel = () => {
  goBack();
};

const getDetail = () => {
  getContractDetail({
    id: id,
    roleType: RoleType[String(roleText).toUpperCase()]
  }).then(({ data }) => {
    detail.value = {
      ...data,
      budgetSettlement: +formatter.fen2yuan(data.budgetSettlement || 0),
      contractTemplateName: data.contractName,
      budgetList: data.budgets,
      contractTemplateUrl: data.contractRenderUrl,
      contractType: data.type
    };
    contractType.value = data.type;
  });
};

getDetail();

return (_ctx: any,_cache: any) => {
  const _directive_xrk_loading = _resolveDirective("xrk-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (detail.value.id)
        ? (_openBlock(), _createBlock(ContractDetail, {
            key: 0,
            disabled: true,
            tableColMid: tableColMid,
            detail: detail.value,
            prefix: "合同",
            pageType: _unref(ContractMenuType).MANAGEMENT,
            contractType: contractType.value
          }, {
            default: _withCtx(({ formData }) => [
              false
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_4,
                    _createVNode(_unref(BaseFormItem), {
                      label: "预计结算总金额",
                      prop: "budgetSettlement"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(BaseInputNumber), {
                          disabled: true,
                          min: 0,
                          max: 100000000,
                          precision: 2,
                          modelValue: formData.budgetSettlement,
                          "onUpdate:modelValue": ($event: any) => ((formData.budgetSettlement) = $event),
                          controls: false,
                          style: {"width":"248px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(BaseTable), {
                      data: formData.budgetList,
                      columns: columns
                    }, null, 8, ["data"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["detail", "pageType", "contractType"]))
        : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, null, 512)), [
            [_directive_xrk_loading, true]
          ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(BaseButton), {
        onClick: handleCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})